import React from "react";
import { goCashImage } from "../../../../config/imageURLs";
import Icon from '../../../../../stories/core-components/IconsSelector';
import * as S from "./GoCash.style";

/*
TODO
    1. deactivate old gocash
*/


const GoCashComp = ({ goCash, margin="", isGocashSelected = false, onGoCashToggle, info = "" }) => {

    const { applicable = {}, user = {} } = goCash ?? {};
    const eligibleBalance = applicable.eligible_gocash ?? 0

    return (
        <S.GoCashComp margin={margin}>
            <S.GoCashHeader>
                <S.GoCashTitle>
                    <S.GoCashIcon src={goCashImage} />
                    <span>goCash</span>
                </S.GoCashTitle>
                <S.GoCashToogleWrap>
                    {isGocashSelected ? (
                        <span className="onText">₹{eligibleBalance} Applied</span>
                    ) : (
                        <span className="offText">Apply ₹{eligibleBalance}</span>
                    )}
                    <S.ToggleBtn>
                        <S.ToggleStatus
                            className={!isGocashSelected ? "buttonOff" : "buttonOn"}
                            onClick={onGoCashToggle}>
                            {!isGocashSelected ? (
                                <span className="off"></span>
                            ) : (
                                <div className="on">
                                    <Icon name='WhiteTickIcon' />
                                </div>
                            )}
                        </S.ToggleStatus>
                    </S.ToggleBtn>
                </S.GoCashToogleWrap>
            </S.GoCashHeader>
            <S.GoCashDetails>
                {`Balance ₹${user.total ?? 0} | Eligible for ₹${eligibleBalance}`}
                {/* {totalbalance && <p className="balance">Total goCash Balance: ₹{totalbalance}</p>} */}
                {info ? <p>{info}</p> : <></>}
            </S.GoCashDetails>
        </S.GoCashComp>
    );
};

export default GoCashComp;
